import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { SplitText } from '@/components/generals/split-text'

interface ArticleQuoteProps {
    quote: string
}

/* The argument of the piece, pulled out and set as a statement. The mark
   scales in first, then the line assembles glyph by glyph behind it. */
export const ArticleQuote: FC<ArticleQuoteProps> = ({ quote }): ReactNode => {
    return (
        <section id='article-quote' className='bg-[#f7f7f7] sec'>
            <div className='mx-auto w-full max-w-[1920px] px-5 lg:px-[33px]'>
                <figure className='mx-auto flex max-w-[1080px] flex-col items-center gap-4 text-center lg:gap-7'>
                    <Reveal from='scale' duration={1.2} start='top 88%'>
                        <span
                            aria-hidden='true'
                            className='t-display block leading-[0.6] text-brand'
                            style={{ fontSize: 'clamp(52px, 6vw, 96px)' }}
                        >
                            &ldquo;
                        </span>
                    </Reveal>

                    <blockquote>
                        <SplitText
                            as='p'
                            text={quote}
                            mode='chars'
                            trigger='scroll'
                            start='top 84%'
                            stagger={0.012}
                            duration={1.05}
                            className='t-display text-center text-ink'
                            style={{ fontSize: 'clamp(28px, 4vw, 60px)' }}
                        />
                    </blockquote>
                </figure>
            </div>
        </section>
    )
}
